import React from "react";
import GradientBanner from "./banner";
import CourseListing from "./recentCourses";
import Sidebar from "../../../components/Sidebar";
import Recommended from "./recommended";
import { AppBar } from "@mui/material";
const RecommendedCourses = () => {
  return (
    <div className="w-full">
      <Sidebar />
      <AppBar
        color="default"
        className="bg-white shadow-md"
        position="relative"
        sx={{
          width: { sm: `calc(100% - ${240}px)` },
          ml: { sm: `240px` },
        }}
      >
      <GradientBanner />
      <CourseListing />
      <Recommended/>
      </AppBar>
    </div>
  );
};
export default RecommendedCourses;
